/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Account_Wallet_ActionInputs */

const en_onboarding_v1_account_wallet_action = /** @type {(inputs: Onboarding_V1_Account_Wallet_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect a wallet`)
};

const de_onboarding_v1_account_wallet_action = /** @type {(inputs: Onboarding_V1_Account_Wallet_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wallet verbinden`)
};

const pt_br2_onboarding_v1_account_wallet_action = /** @type {(inputs: Onboarding_V1_Account_Wallet_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar uma carteira`)
};

const tr_onboarding_v1_account_wallet_action = /** @type {(inputs: Onboarding_V1_Account_Wallet_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cüzdan bağla`)
};

const zh_cn2_onboarding_v1_account_wallet_action = /** @type {(inputs: Onboarding_V1_Account_Wallet_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接钱包`)
};

const zh_hk2_onboarding_v1_account_wallet_action = /** @type {(inputs: Onboarding_V1_Account_Wallet_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連接錢包`)
};

const ko_kr2_onboarding_v1_account_wallet_action = /** @type {(inputs: Onboarding_V1_Account_Wallet_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지갑 연결`)
};

const ru_ru2_onboarding_v1_account_wallet_action = /** @type {(inputs: Onboarding_V1_Account_Wallet_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключить кошелек`)
};

const es_419_onboarding_v1_account_wallet_action = /** @type {(inputs: Onboarding_V1_Account_Wallet_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar una billetera`)
};

/**
* | output |
* | --- |
* | "Connect a wallet" |
*
* @param {Onboarding_V1_Account_Wallet_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_account_wallet_action = /** @type {((inputs?: Onboarding_V1_Account_Wallet_ActionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Account_Wallet_ActionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_account_wallet_action(inputs)
	if (locale === "de") return de_onboarding_v1_account_wallet_action(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_account_wallet_action(inputs)
	if (locale === "tr") return tr_onboarding_v1_account_wallet_action(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_account_wallet_action(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_account_wallet_action(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_account_wallet_action(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_account_wallet_action(inputs)
	return es_419_onboarding_v1_account_wallet_action(inputs)
});